module.exports = __webpack_public_path__ + "static/media/industrial_3.d5416f34.jpg";